export default {
    HOST: "backend.equisym.com",
    PORT: 443
  };
  